import { render, staticRenderFns } from "./emba.vue?vue&type=template&id=f9bdb99c&scoped=true"
import script from "./emba.vue?vue&type=script&lang=ts"
export * from "./emba.vue?vue&type=script&lang=ts"
import style0 from "./emba.vue?vue&type=style&index=0&id=f9bdb99c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9bdb99c",
  null
  
)

export default component.exports